<script lang="ts">
  import {
    fishHeightCoefficient,
    fishLeftCoefficient,
    fishWidthCoefficient,
    seaHeightCoefficient,
  } from './pitcyFishConstants';

  export let containerHeight: number;
  export let containerWidth: number;
  export let isVisible: boolean;
  export let lowestMidi: number;
  export let highestMidi: number;
  export let midi: number;

  $: left = containerWidth * fishLeftCoefficient;
  $: fishWidth = containerWidth * fishWidthCoefficient;
  $: fishHeight = containerHeight * fishHeightCoefficient;
  $: seaHeight = containerHeight * seaHeightCoefficient;

  let fishYCoefficient = 0.5;
  let y = containerHeight - seaHeight / 2;

  /**
   * Returns the VISIBLE y coefficient, which is not necessarily the same as the
   * fishYCoefficient variable. This function is used for collision detection.
   */
  export function getYCoefficient() {
    return y / seaHeight;
  }

  let lastUpdateMoment: number | undefined;
  export const updatePosition = () => {
    const maxY = containerHeight - fishHeight;
    const minY = 0;
    if (midi === -1) {
      fallFish();
    } else {
      const priorYCoefficient = getYCoefficient();
      // Max distance per second is 100% (avoid jumps)
      const maxYCoefficientChangePerSecond = 1;
      const newFishYCoefficient = (midi - lowestMidi) / (highestMidi - lowestMidi);
      const timeSinceLastUpdate = lastUpdateMoment ? Date.now() - lastUpdateMoment : 0;
      // Biggest change allowed is:
      const biggestChangeThisFrame = maxYCoefficientChangePerSecond / (1000 / timeSinceLastUpdate);
      // If it's a bigger change:
      if (Math.abs(priorYCoefficient - newFishYCoefficient) > biggestChangeThisFrame) {
        // set the fish y coefficient to the biggest allowed change:
        fishYCoefficient =
          // If we're going down:
          priorYCoefficient > newFishYCoefficient
            ? // Subtract the biggest allowed change from the fishYCoefficient
              priorYCoefficient - biggestChangeThisFrame
            : // Otherwise add it
              priorYCoefficient + biggestChangeThisFrame;
      } else {
        fishYCoefficient = newFishYCoefficient;
      }
      // console.log(
      //   `prior: ${priorYCoefficient.toFixed(2)}, new: ${newFishYCoefficient.toFixed(
      //     2,
      //   )}, change: ${Math.abs(priorYCoefficient - newFishYCoefficient).toFixed(
      //     2,
      //   )}, max allowed: ${biggestChangeThisFrame.toFixed(2)}, used: ${fishYCoefficient}`,
      // );

      y = seaHeight * fishYCoefficient;
      y = Math.min(maxY, y);
      y = Math.max(minY, y);

      // if (y < 0) {
      //   y = 0;
      // }
    }
    lastUpdateMoment = Date.now();
    // console.log({ fishYCoefficient, y, seaHeight, midi });
  };

  function fallFish() {
    const timeSinceLastUpdate = lastUpdateMoment ? Date.now() - lastUpdateMoment : 0;

    // Fall at 20% per second...
    const fallPercent = (timeSinceLastUpdate / 1000) * 0.1;
    const fallDistance = seaHeight * fallPercent;
    y = Math.min(containerHeight - fishHeight, y - fallDistance);
  }
</script>

{#if isVisible}
  <!-- FISH DIV -->
  <div
    style="bottom: {y}px;
    left: {left}px; height: {fishHeight}px;
    width: {fishWidth}px;"
    class="fish"
  >
    <img src="/assets/pitchy-fish/fish.gif" alt="fish" style="width: 100%; height: 100%" />
  </div>
  <!-- END FISH DIV -->
{/if}

<style>
  .fish {
    position: absolute;
    z-index: 4;
  }
</style>
